export default __webpack_public_path__ + "static/media/Triology2.71fd675d.jpg";